import React from "react";
import { FormattedMessage } from "react-intl";
import { Box, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(theme => ({
  leftIconContainer: {
    width: 32,
  },
  rowItem: {
    paddingLeft: 10,
    paddingRight: 10,
    marginBottom: 0,
    height: 50,
    "&:hover": {
      "& span": {
        opacity: 1,
      },
    },
    [theme.breakpoints.down("sm")]: {
      paddingRight: 0,
      height: "auto",
      marginBottom: 20,
    },
  },
  title: {
    flex: 1,
  },
}));

const GroupRowItem = ({
  title,
  leftIcon,
  userGroupBreadCrumb
}) => {
  const classes = useStyles();

  return (
    <Box display="flex" className={classes.rowItem}>
      <Box alignItems="center" className={classes.leftIconContainer}>
        <span>{leftIcon}</span>
      </Box>
      <Box display="flex" flexDirection="column" className={classes.title}>
        <Typography style={{ fontSize: 14 }}>
          {Array.isArray(userGroupBreadCrumb?.groups)
            ? userGroupBreadCrumb.groups.map(n => n?.name ?? "").join(" » ")
            : ""}
        </Typography>
        <Typography style={{ fontSize: 12, color: "rgba(0,0,0,0.55)" }}>
          <FormattedMessage id="settings.companyUserGroup" />
        </Typography>
        
      </Box>
    </Box>
  );
};

export default GroupRowItem;